import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const DatePickerButton = ({ onClick, placeholderDefaultText, value }) => (
  <button
    className={classnames(
      'brzw-buttons datepicker-custom-input form-control form-group-row__input',
      { 'datepicker-custom-input-placeholder': !value },
    )}
    onClick={onClick}
    type="button"
  >
    {value || placeholderDefaultText}
  </button>
);

DatePickerButton.propTypes = {
  onClick: PropTypes.func,
  placeholderDefaultText: PropTypes.string,
  value: PropTypes.string,
};

DatePickerButton.defaultProps = {
  placeholderDefaultText: '',
};

export default DatePickerButton;
